// --- Configuration ---
export const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const API_BASE_URL = isLocal
  ? 'http://localhost:5001'
  : 'https://api.pleadperfect.com';

console.log(API_BASE_URL)